module.exports = __webpack_public_path__ + "static/media/Libertybusiness-eng.a041ec33.svg";